/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { paisActivosGet } from '../fn/country/pais-activos-get';
import { PaisActivosGet$Params } from '../fn/country/pais-activos-get';
import { paisGet } from '../fn/country/pais-get';
import { PaisGet$Params } from '../fn/country/pais-get';
import { paisIdCountryGet } from '../fn/country/pais-id-country-get';
import { PaisIdCountryGet$Params } from '../fn/country/pais-id-country-get';

@Injectable({ providedIn: 'root' })
export class CountryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `paisGet()` */
  static readonly PaisGetPath = '/pais';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paisGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paisGet$Response(params?: PaisGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return paisGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paisGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paisGet(params?: PaisGet$Params, context?: HttpContext): Observable<any> {
    return this.paisGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `paisActivosGet()` */
  static readonly PaisActivosGetPath = '/pais/activos';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paisActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paisActivosGet$Response(params?: PaisActivosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return paisActivosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paisActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paisActivosGet(params?: PaisActivosGet$Params, context?: HttpContext): Observable<any> {
    return this.paisActivosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `paisIdCountryGet()` */
  static readonly PaisIdCountryGetPath = '/pais/{idCountry}';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paisIdCountryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paisIdCountryGet$Response(params: PaisIdCountryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return paisIdCountryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paisIdCountryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paisIdCountryGet(params: PaisIdCountryGet$Params, context?: HttpContext): Observable<any> {
    return this.paisIdCountryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
